import React, { useState, useEffect } from 'react';
import colors from '../theme/colors';

const LoaderWithDots = ({ isLoading, text }) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    let timer;

    if (isLoading) {
      timer = setInterval(() => {
        setDots((prev) => (prev.length < 3 ? prev + '.' : ''));
      }, 500);
    } else {
      clearInterval(timer);
      setDots('');
    }

    return () => clearInterval(timer);
  }, [isLoading]);

  return (
    isLoading && (
      <div style={styles.container}>
        <span style={styles.loaderText}>{text}{dots}</span>
      </div>
    )
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    borderRadius: '10px',
  },
  loaderText: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: colors.secondary
  },
};

export default LoaderWithDots;
